export function postDataRequest(data: any): RequestInit {
  return ({
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include' as RequestCredentials,
    body: JSON.stringify(data)
  });
}
